import { render, staticRenderFns } from "./AddTerminalModal.vue?vue&type=template&id=60017c43&"
import script from "./AddTerminalModal.vue?vue&type=script&lang=js&"
export * from "./AddTerminalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports